import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useStyles = makeStyles(theme => ({
  header: {
    marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginBottom: 10
    }
  },
  headerTitle: {
    fontSize: 24,
    fontWeight: 600,
    color: GRAY_COLORS[900],
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    }
  },
  headerItems: {
    display: 'flex',
    gap: 12,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  actionButtons: {
    marginBottom: 20,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'nowrap'
    },
    justifyContent:'space-between'
  },
  arrowLeft: {
    marginTop: 32,
    marginBottom: 32,
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      marginBottom: 20
    }
  },
  backButton: {
    padding: 0,
    margin: 0
  }
}))
